/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type RequestNewDatasetUploadUrlPathParams = NonNullable<
  operations['requestNewDatasetUploadUrl']['parameters']['path']
>;

export type RequestNewDatasetUploadUrlRequestBody = OperationRequestBodyContent<
  operations['requestNewDatasetUploadUrl']
>;

export interface Input extends RequestNewDatasetUploadUrlPathParams {
  apiVersion?: string;
  body: RequestNewDatasetUploadUrlRequestBody;
}

export async function requestNewDatasetUploadUrl(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/projects/{projKey}/datasets/{datasetId}/upload-url', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
